import {AsyncInlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class SortUserFavoritesService extends Service {
  #config
  #search
  #items

  constructor({config, search, items}) {
    super()
    this.#config = config
    this.#search = search
    this.#items = items
  }

  static validate({search, items}) {
    if (!search || !items)
      throw InvalidParamsSharedError.create(`[SortUserFavoritesService.validate] search and items params are required`)
  }

  static create({config, search, items}) {
    SortUserFavoritesService.validate({search, items})
    return new SortUserFavoritesService({config, search, items})
  }

  @AsyncInlineError()
  async execute() {
    return this.#sortItems()
  }

  #sortItems() {
    const {sortBy, sortOrder} = this.#search

    if (sortBy === this.#config.get('SORT_FIELDS').RELEVANCE) {
      return {...this.#items}
    }

    const orderFactor = sortOrder.toLowerCase() === 'desc' ? -1 : 1

    const rentingFavouritesItems = this.#items.ads?.filter(item => item.monthlySubscriptionFee)
    const nonRentingFavouritesItems = this.#items.ads?.filter(item => !item.monthlySubscriptionFee)

    nonRentingFavouritesItems.sort((itemA, itemB) => {
      return this.#compareValues(itemA, itemB, sortBy, orderFactor)
    })

    rentingFavouritesItems.sort(this.#compareMonthlySubscriptionFees(orderFactor))

    this.#items.ads = [...nonRentingFavouritesItems, ...rentingFavouritesItems]

    return {...this.#items}
  }

  #compareMonthlySubscriptionFees(orderFactor) {
    return (itemA, itemB) => (itemA.monthlySubscriptionFee - itemB.monthlySubscriptionFee) * orderFactor
  }

  #compareValues(itemA, itemB, sortBy, orderFactor) {
    const getValue = this.#config.get('favorites').SORTABLE_FAVORITE_FIELDS[sortBy]
    const valueA = getValue(itemA)
    const valueB = getValue(itemB)
    return (valueA - valueB) * orderFactor
  }
}
